import FJVideoRemoveBgBg from '../view/FJVideoRemoveBgBg';
import { useSelector, useDispatch } from 'react-redux';
import { useState, useCallback, useMemo } from 'react';

import FJLocalStore from '../../../../store/FJLocalStore';
import { useEffect } from 'react';
import FJActionAiHistoryCommon from '../../../../redux/action/FJActionAiHistoryCommon';
import FJActionColorCommon from '../../../../redux/action/FJActionColorCommon';
import useLocalStore from '../../../../hooks/useLocalStore';
import FJActionVideoRemoveBg from '../../../../redux/action/FJActionVideoRemoveBg';
import FJUtil from '../../../../util/FJUtil';
import FJTextToImageConfig from '../../../../config/appConfig/FJTextToImageConfig';
import FJActionEditPage from '../../../../redux/action/FJActionEditPage.js';

const MENU_TAB_LIST = [
    {
        text: FJLocalStore._('photo'),
    },
    {
        text: FJLocalStore._('color'),
    },
    {
        text: FJLocalStore._('ai-photo'),
    },
];

const FJVideoRemoveBgBgContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();

    const [curMenuIndex, setCurMenuIndex] = useState(1);
    const curLanguage = FJLocalStore.currentTag();

    const flexClipBgLoadStatus = useSelector(state => state.videoBgRemover.flexClipBgLoadStatus);
    const backgroundPhotoList = useSelector(state => state.videoBgRemover.backgroundPhotoList);
    const aiTextToImageHistoryList = useSelector(state => state.aiHistoryCommon.aiTextToImageHistoryList);
    const aiTextToImageHistoryLoadStatus = useSelector(state => state.aiHistoryCommon.aiTextToImageHistoryLoadStatus);
    const selectColorList = useSelector(state => state.colorCommon.selectColorList);
    const defaultColorList = useSelector(state => state.colorCommon.defaultColorList);
    const curSelectBgData = useSelector(state => state.videoBgRemover.curSelectBgData);
    const curBgColor = useSelector(state => state.videoBgRemover.curBgColor);
    const customUploadBgFileList = useSelector(state => state.videoBgRemover.customUploadBgFileList);
    const bgUsePhotoLoadingList = useSelector(state => state.videoBgRemover.bgUsePhotoLoadingList);

    const colorList = useMemo(() => {
        return [...selectColorList, ...defaultColorList];
    }, [selectColorList, defaultColorList]);

    useEffect(() => {
        if (curMenuIndex === 2) {
            dispatch(FJActionAiHistoryCommon.initAiTextToImageHistoryList());
        }
    }, [curMenuIndex, dispatch]);

    const showBgListModel = useCallback(() => {
        dispatch(FJActionVideoRemoveBg.initFlexClipBackgroundData());
    }, [dispatch]);

    const hideBgListModel = useCallback(() => {}, []);

    const handleColorChange = useCallback(
        (color, changeType) => {
            dispatch(FJActionVideoRemoveBg.setBackgroundColorAction(color, changeType));
        },
        [dispatch],
    );

    const addSelectColor = useCallback(() => {
        if (curBgColor === '') return;
        dispatch(FJActionColorCommon.addSelectColorListAction(curBgColor));
    }, [dispatch, curBgColor]);

    const handleBgItemClick = useCallback(
        (item, isAiPhoto = false) => {
            dispatch(FJActionVideoRemoveBg.setBackgroundImageAction(item, isAiPhoto));
        },
        [dispatch],
    );

    const uploadBg = useCallback(
        file => {
            dispatch(FJActionVideoRemoveBg.uploadBgAction(file));
        },
        [dispatch],
    );

    const removeClick = useCallback(() => {
        dispatch(FJActionVideoRemoveBg.removeBgAction());
    }, [dispatch]);

    const handleGenerateNow = useCallback(() => {
        window.open(
            `${curLanguage === 'en' ? '' : '/' + curLanguage}${FJUtil.getAIToolHref(FJTextToImageConfig.currentMenuName)}`,
        );
    }, [curLanguage]);

    const onClickRetry = useCallback(() => {
        dispatch(FJActionVideoRemoveBg.initFlexClipBackgroundData());
    }, [dispatch]);

    const onClickAiRetry = useCallback(() => {
        dispatch(FJActionAiHistoryCommon.initAiTextToImageHistoryList());
    }, [dispatch]);

    const _openMediaLibrary = useCallback(() => {
        window.mediaLibraryOptions = {
            isBgUpload: true,
        };
        dispatch(FJActionEditPage.openMediaLibraryAction({ fromType: 'image-in-video-remove' }));
    }, [dispatch]);

    return (
        <FJVideoRemoveBgBg
            flexClipBgLoadStatus={flexClipBgLoadStatus}
            backgroundPhotoList={backgroundPhotoList}
            customUploadBgFileList={customUploadBgFileList}
            menuTabList={MENU_TAB_LIST}
            curMenuIndex={curMenuIndex}
            aiTextToImageHistoryList={aiTextToImageHistoryList}
            aiTextToImageHistoryLoadStatus={aiTextToImageHistoryLoadStatus}
            colorList={colorList}
            activeColor={curBgColor}
            curSelectBgData={curSelectBgData}
            bgUsePhotoLoadingList={bgUsePhotoLoadingList}
            handleColorChange={handleColorChange}
            hideBgListModel={hideBgListModel}
            showBgListModel={showBgListModel}
            setCurMenuIndex={setCurMenuIndex}
            addSelectColor={addSelectColor}
            handleBgItemClick={handleBgItemClick}
            uploadBg={uploadBg}
            handleGenerateNow={handleGenerateNow}
            removeClick={removeClick}
            onClickRetry={onClickRetry}
            onClickAiRetry={onClickAiRetry}
            openMediaLibrary={_openMediaLibrary}
        />
    );
};

export default FJVideoRemoveBgBgContainer;
